import AnimatedNumber from "./AnimatedNumber";

const ITEMS = [
  { key: "today", label: "سرویس‌های امروز" },
  { key: "month", label: "سرویس‌های این ماه" },
  { key: "year", label: "سرویس‌های امسال" },
  { key: "customers", label: "مشتری‌ها" },
];

function ServicePerformance({ stats, loading, error, onRetry }) {
  return (
    <section
      className="service-performance"
      aria-label="آمار عملکرد سرویس‌کار"
      aria-busy={loading}
    >
      <div className="service-performance__grid">
        {ITEMS.map((item) => (
          <article className="service-performance__card" key={item.key}>
            <span className="service-performance__accent" aria-hidden="true" />
            <span className="service-performance__label">{item.label}</span>
            {loading ? (
              <span className="service-performance__skeleton" aria-hidden="true" />
            ) : (
              <AnimatedNumber value={stats[item.key]} />
            )}
          </article>
        ))}
      </div>

      {error && !loading && (
        <div className="service-performance__error" role="alert">
          <span>{error}</span>
          <button type="button" onClick={onRetry}>تلاش دوباره</button>
        </div>
      )}
    </section>
  );
}

export default ServicePerformance;
